<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-dialog
        v-model="dialog"
        persistent :overlay="false"
        transition="dialog-transition"
        max-width="400px"
      >
        <v-card>
          <v-card-text class="text-xs-center">
            <v-progress-circular :indeterminate="true" size="80" color="blue" v-if="problem==null" class="mt-5 mb-2"></v-progress-circular>
            <h3 class="mt-5 mb-3" v-if="problem==null">{{aktualni_stav}}</h3>
            <h3 v-else class="mb-3 mt-3 red--text">{{problem}}</h3>
            <v-btn color="grey" class="mt-3" flat @click="dialog=false" v-if="problem!=null">Zavřít</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <h2 class="mb-2">Nová objednávka dodavatelům</h2>
            <div v-if="status=='ok'">
              <div class="table-border__radius elevation-2 mt-3 pb-3">
                <h3 class="mt-4 pl-4 pt-3">Spořící nákupy z&nbsp;fixace</h3>
                <v-data-table
                  :headers="headers"
                  :items="produkty"
                  class="no__hover ml-4 mr-4"
                  item-key="row_id"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td class="subheading vertical-top pt-4">
                      <div class="mt-4 pt-2">
                        <router-link :to="{ path: '/produkty/' + props.item.cilovy_produkt.id }" target="_blank">
                          {{ props.item.cilovy_produkt.nazev }}
                        </router-link>
                      </div>
                    </td>
                    <td class="text-xs-right subheading vertical-top pt-4">
                      <div class="mt-4 pt-2">
                        {{ props.item.fixovane_mnozstvi | formatMoney }}g
                      </div>
                    </td>
                    <td class="subheading">
                      <v-layout row wrap v-if="props.item.cilovy_produkt.typ_produktu=='mince'" class="mt-2 mb-3">
                        <v-flex xs3 class="pl-3">
                          <span class="caption">Stav skladu:</span>
                          <div><span v-if="props.item.stav_skladu_fyzicky>0">{{ props.item.stav_skladu_fyzicky | formatInt }}</span><span v-else>--</span></div>
                        </v-flex>
                        <v-flex xs3>
                          <span class="caption">Na cestě:</span>
                          <div><span v-if="props.item.stav_na_ceste>0">{{ props.item.stav_na_ceste | formatInt }}</span><span v-else>--</span></div>
                        </v-flex>
                        <v-flex xs3>
                          <span class="caption">Zboží klientů:</span>
                          <div><span v-if="props.item.stav_objednane>0">{{ props.item.stav_objednane | formatInt }}</span><span v-else>--</span></div>
                        </v-flex>
                        <v-flex xs3>
                          <span class="caption">Vykoupeno:</span>
                          <div><span v-if="props.item.stav_vykoupeno>0">{{ props.item.stav_vykoupeno | formatInt }}</span><span v-else>--</span></div>
                        </v-flex>
                      </v-layout>
                      <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-4 pr-4">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 class="d-flex align-center pr-2">
                            {{ props.item.cilovy_produkt.nazev }}:
                          </v-flex>
                          <v-flex xs12 sm8>
                            <v-layout row class="mt-2">
                              <v-flex xs12 sm3>
                                <v-text-field
                                  hide-details
                                  class="mb-3 mt-0 mx-2"
                                  v-model="props.item.ks"
                                  :max="props.item.max_ks >= 0 ? props.item.max_ks : 999"
                                  :min="0"
                                  :suffix="props.item.max_ks >= 0 ? (' / ' + props.item.max_ks) : ''"
                                  type="number"
                                  @input="() => { props.item.g = (props.item.fixovane_mnozstvi - parseIntNull(props.item.ks) * props.item.vaha_g  - (props.item.nahradni_produkt != null && props.item.nahradni_produkt.ks.toString().length > 0 ? parseIntNull(props.item.nahradni_produkt.ks) * props.item.nahradni_produkt.vaha_g : 0)).toFixed(2).replace(',', '.'); }"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm2 class="mx-2 orange--text pt-3">
                                <span class="subheading" v-if="props.item.max_ks >= 0 && props.item.ks > props.item.max_ks">Max. {{props.item.max_ks}}ks</span>
                              </v-flex>
                              <v-flex xs12 sm7>
                                <dodavateleproduktuselect :produkt="props.item.cilovy_produkt.id" class="mt-0 mx-2 d-flex" v-model="props.item.dodavatel_id" :dodavatele="props.item.dodavatele"></dodavateleproduktuselect>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-4 pr-4">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 class="d-flex align-center pr-3 pt-2">
                            <nahradniproduktyuselect class="mt-0 mr-2 d-flex mx-0" noMx label="Vyberte náhradní produkt" @changed="(e) => { props.item.nahradni_produkt = e; }" :nahradniprodukty="props.item.nahradni_produkty" :produkt="props.item.cilovy_produkt.id"></nahradniproduktyuselect>
                          </v-flex>
                          <v-flex xs12 sm8 v-if="props.item.nahradni_produkt != null">
                            <v-layout row class="mt-2">
                              <v-flex xs12 sm3>
                                <v-text-field
                                  hide-details
                                  class="mb-3 mt-0 mx-2"
                                  v-model="props.item.nahradni_produkt.ks"
                                  :max="props.item.max_ks >= 0 ? props.item.max_ks : 999"
                                  :min="0"
                                  :suffix="props.item.max_ks >= 0 ? (' / ' + props.item.max_ks) : ''"
                                  type="number"
                                  @input="() => { props.item.g = (props.item.fixovane_mnozstvi - parseIntNull(props.item.ks) * props.item.vaha_g  - (props.item.nahradni_produkt != null && props.item.nahradni_produkt.ks.toString().length > 0 ? parseIntNull(props.item.nahradni_produkt.ks) * props.item.nahradni_produkt.vaha_g : 0)).toFixed(2).replace(',', '.'); }"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm2 class="mx-2 orange--text pt-3">
                                <span class="subheading" v-if="props.item.max_ks >= 0 && props.item.ks > props.item.max_ks">Max. {{props.item.max_ks}}ks</span>
                              </v-flex>
                              <v-flex xs12 sm7>
                                <dodavateleproduktuselect class="mt-0 mx-2 d-flex" v-model="props.item.nahradni_produkt.dodavatel_id" :dodavatele="props.item.nahradni_produkt.dodavatele"></dodavateleproduktuselect>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-4 pr-4">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 class="d-flex">
                            <div class="mt-4">
                              Metal konto (g):
                            </div>
                          </v-flex>
                          <v-flex xs12 sm8>
                            <v-layout row class="mt-2">
                              <v-flex xs12 sm3>
                                <v-text-field
                                  hide-details
                                  class="mb-3 mt-0 mx-2 pr-2"
                                  v-model="props.item.g"
                                  :min="0"
                                  type="number"
                                  readonly
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm2 class="mx-2 orange--text pt-3">
                                <!-- <span class="" v-if="parseFloat(props.item.g) < 0">Záporné metal konto</span> -->
                              </v-flex>
                              <v-flex xs12 sm7>
                                <dodavateleproduktuselect :produkt="props.item.cilovy_produkt.id" class="mx-2" v-model="props.item.metal_konto_dodavatel_id" :dodavatele="metal_konto_dodavatele" @changed="(e) => { aktualizovatStavMetalKonta(props.item) }" :metal_konto="true"></dodavateleproduktuselect>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </td>
                  </template>
                </v-data-table>
              </div>
              <!-- <h3 class="mt-4 pl-4">Přidat produkt do spořících nákupů:</h3>
              <div class="table-border__radius elevation-1 mt-3 pl-2 pr-2">
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 sm3>
                      <productsearch v-model="pridat_produkt_id" hide-details label="Hledat produkt"></productsearch>
                    </v-flex>
                    <v-flex xs12 sm9 class="pt-1" v-if="pridat_produkt_id != null">
                      <v-btn color="primary" class="mt-2" :class="{'ml-0': $vuetify.breakpoint.xs}" depressed @click="pridatProduktClick" :loading="loading_produkt">Přidat produkt</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </div> -->
              <div class="table-border__radius elevation-2 mt-3 pb-3">
                <h3 class="mt-4 pl-4 pt-3">Jednorázové nákupy z fixace</h3>
                <v-data-table
                  :headers="headers"
                  :items="jednorazove_nakupy_produkty"
                  class="no__hover ml-4 mr-4"
                  item-key="row_id"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td class="subheading vertical-top pt-4">
                      <div class="mt-4 pt-2">
                        <router-link :to="{ path: '/produkty/' + props.item.cilovy_produkt.id }" target="_blank">
                          {{ props.item.cilovy_produkt.nazev }}
                        </router-link>
                      </div>
                    </td>
                    <td class="text-xs-right subheading vertical-top pt-4">
                      <div class="mt-4 pt-2">
                        {{ props.item.fixovane_mnozstvi | formatInt }} ks
                      </div>
                    </td>
                    <td class="subheading">
                      <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-4 pr-4">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 class="d-flex align-center pr-2">
                            {{ props.item.cilovy_produkt.nazev }}:
                          </v-flex>
                          <v-flex xs12 sm8>
                            <v-layout row class="mt-2">
                              <v-flex xs12 sm3>
                                <v-text-field
                                  hide-details
                                  class="mb-3 mt-0 mx-2"
                                  v-model="props.item.ks"
                                  :max="props.item.max_ks >= 0 ? props.item.max_ks : 999"
                                  :min="0"
                                  :suffix="props.item.max_ks >= 0 ? (' / ' + props.item.max_ks) : ''"
                                  type="number"
                                  @input="() => { props.item.g = ((props.item.fixovane_mnozstvi - parseIntNull(props.item.ks)) * props.item.vaha_g).toFixed(2).replace(',', '.'); }"
                                  :disabled="props.item.neni_dodavatel"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm2 class="mx-2 orange--text pt-3">
                                <span class="subheading" v-if="props.item.max_ks >= 0 && props.item.ks > props.item.max_ks">Max. {{props.item.max_ks}}ks</span>
                              </v-flex>
                              <v-flex xs12 sm7>
                                <dodavateleproduktuselect :produkt="props.item.cilovy_produkt.id" class="mt-0 mx-2 d-flex" v-model="props.item.dodavatel_id" :dodavatele="props.item.dodavatele"></dodavateleproduktuselect>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-4 pr-4">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 class="d-flex align-center">
                            Metal konto (g):
                          </v-flex>
                          <v-flex xs12 sm8>
                            <v-layout row class="mt-2">
                              <v-flex xs12 sm3>
                                <v-text-field
                                  hide-details
                                  class="mb-3 mt-0 mx-2 pr-2"
                                  v-model="props.item.g"
                                  :min="0"
                                  type="number"
                                  readonly
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm2 class="mx-2 orange--text pt-3">
                                <!-- <span class="subheading" v-if="parseFloat(props.item.g) < 0">Záporné metal konto</span> -->
                              </v-flex>
                              <v-flex xs12 sm7>
                                <dodavateleproduktuselect :produkt="props.item.cilovy_produkt.id" class="mx-2" v-model="props.item.metal_konto_dodavatel_id" :dodavatele="metal_konto_dodavatele" :metal_konto="true"></dodavateleproduktuselect>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </td>
                  </template>
                </v-data-table>
              </div>
              <div class="table-border__radius elevation-2 mt-3 pb-4">
                <h3 class="mt-4 pl-4 pt-3">Objednat další produkty</h3>
                <v-data-table
                  :headers="ostatniProduktyHeaders"
                  :items="ostatni_produkty"
                  class="no__hover ml-4 mr-4"
                  item-key="row_id"
                  hide-actions
                >
                  <template slot="items" slot-scope="props">
                    <td class="subheading vertical-top pt-4">
                      <div class="mt-4 pt-2">
                        <router-link :to="{ path: '/produkty/' + props.item.cilovy_produkt.id }" target="_blank">
                          {{ props.item.cilovy_produkt.nazev }}
                        </router-link>
                      </div>
                    </td>
                    <td class="subheading">
                      <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-4 pr-4">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 class="d-flex align-center pr-2">
                            {{ props.item.cilovy_produkt.nazev }}:
                          </v-flex>
                          <v-flex xs12 sm8>
                            <v-layout row class="mt-2">
                              <v-flex xs12 sm3>
                                <v-text-field
                                  hide-details
                                  class="mb-3 mt-0 mx-2"
                                  v-model="props.item.ks"
                                  :max="props.item.max_ks >= 0 ? props.item.max_ks : 999"
                                  :min="0"
                                  :suffix="props.item.max_ks >= 0 ? (' / ' + props.item.max_ks) : ''"
                                  type="number"
                                  @input="() => { props.item.g = ((props.item.fixovane_mnozstvi - parseIntNull(props.item.ks)) * props.item.vaha_g).toFixed(2).replace(',', '.'); }"
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm2 class="mx-2 orange--text pt-3">
                                <span class="subheading" v-if="props.item.max_ks >= 0 && props.item.ks > props.item.max_ks">Max. {{props.item.max_ks}}ks</span>
                              </v-flex>
                              <v-flex xs12 sm7>
                                <dodavateleproduktuselect :produkt="props.item.cilovy_produkt.id" class="mt-0 mx-2 d-flex" v-model="props.item.dodavatel_id" :dodavatele="props.item.dodavatele"></dodavateleproduktuselect>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                      <v-card class="grey lighten-3 mt-2 mb-2 no__radius pl-4 pr-4">
                        <v-layout row wrap>
                          <v-flex xs12 sm4 class="d-flex align-center pt-1">
                            <v-checkbox v-model="props.item.hlidat_metal_konto" label="Metal konto (g):" class="mt-3"></v-checkbox>
                          </v-flex>
                          <v-flex xs12 sm8 v-if="props.item.hlidat_metal_konto">
                            <v-layout row class="mt-2">
                              <v-flex xs12 sm3>
                                <v-text-field
                                  hide-details
                                  class="mb-3 mt-0 mx-2 pr-2"
                                  v-model="props.item.g"
                                  :min="0"
                                  type="number"
                                  readonly
                                ></v-text-field>
                              </v-flex>
                              <v-flex xs12 sm2 class="mx-2 orange--text pt-3">
                                <!-- <span class="subheading" v-if="parseFloat(props.item.g) < 0">Záporné metal konto</span> -->
                              </v-flex>
                              <v-flex xs12 sm7>
                                <dodavateleproduktuselect :produkt="props.item.cilovy_produkt.id" class="mx-2" v-model="props.item.metal_konto_dodavatel_id" :dodavatele="metal_konto_dodavatele" :metal_konto="true"></dodavateleproduktuselect>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </td>
                  </template>
                </v-data-table>
                <v-divider class="ml-4 mr-4 mt-3 mb-3"></v-divider>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md6 lg3>
                    <productsearch v-model="pridat_produkt_id" hide-details label="Hledat produkt pro přidání" class="ml-4" outline></productsearch>
                  </v-flex>
                  <v-flex xs12 sm6 md6 lg3 class="pt-1" v-if="pridat_produkt_id != null">
                    <v-btn color="primary" class="mt-2" :class="{'ml-0': $vuetify.breakpoint.xs}" depressed @click="pridatProduktClick" :loading="loading_produkt">Přidat produkt</v-btn>
                  </v-flex>
                </v-layout>
              </div>
              <h3 class="mt-5" v-if="vyrobci != null && vyrobci.length > 0">Objednávky u jednotlivých výrobců</h3>
              <v-card v-for="v in vyrobci" :key="'objednavky-'+v.id.toString()" class="grey lighten-3 no__radius mt-3" v-if="vyrobci != null && vyrobci.length > 0">
                <v-card-text>
                  <v-layout row>
                    <v-flex xs12>
                      <h2>{{v.nazev}}</h2>
                    </v-flex>
                  </v-layout>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-data-table
                        :headers="produktyHeaders"
                        :items="v.produkty"
                        class="no__hover mt-2 transparent"
                        hide-actions
                      >
                        <template slot="items" slot-scope="props">
                          <td class="subheading">
                            <router-link :to="{ path: '/produkty/' + props.item.produkt_id }" target="_blank" v-if="props.item.typ=='produkt'">
                              {{ props.item.nazev }}
                            </router-link>
                            <span v-else>{{ props.item.nazev }}</span>
                          </td>
                          <td class="text-xs-right subheading">
                            <span v-if="props.item.typ=='produkt'" :class="{ 'red--text': props.item.ks < 0 }">{{ props.item.ks }} ks</span><span v-else :class="{ 'red--text': props.item.metal_konto < 0 }">{{ props.item.metal_konto | formatMoney }} g</span>
                          </td>
                          <td>
                            <span v-if="!props.item.hlidat_metal_konto">Neodečteno z fixovaného množství.</span>
                          </td>
                        </template>
                      </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </v-card>
              <v-layout row wrap class="mt-5 mb-5">
                <v-flex xs12 class="text-xs-center">
                  <v-btn color="green" depressed large dark @click="vytvoritObjednavku" v-if="vyrobci != null && vyrobci.length > 0 && objednavka_ok">Sestavit objednávku</v-btn>
                </v-flex>
              </v-layout>
            </div>
            <div v-else-if="status=='error_produkty_bez_dodavatelu'">
              <v-data-table
                :headers="produktyBezDodavateluHeaders"
                :items="produkty_bez_dodavatelu"
                class="mx-2 mt-3"
                color="transparent"
                hide-actions
              >
                <template slot="items" slot-scope="props">
                  <td>
                    <router-link :to="{ path: '/produkty/' + props.item.id + '/upravit' }" target="_blank">
                      {{ props.item.nazev }}
                    </router-link>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data: function () {
    return {
      loading: true,
      headers: [
        { text: 'Produkt', value: 'cilovy_produkt', sortable: false, width: '250px' },
        { text: 'Fixované množství', value: 'fixovane_mnozstvi', sortable: false, align: "right", width: '150px' },
        { text: 'Objednat', value: 'fixovane_mnozstvi', sortable: false }
      ],
      ostatniProduktyHeaders: [
        { text: 'Produkt', value: 'cilovy_produkt', sortable: false, width: '400px' },
        { text: 'Objednat', value: 'fixovane_mnozstvi', sortable: false }
      ],
      produktyHeaders: [
        { text: 'Produkt', value: 'nazev', sortable: false, width: "300px" },
        { text: 'Množství', value: 'ks', sortable: false, width: "180px", align: "right" },
        { text: '', value: '', sortable: false, align: "right" }
      ],
      produktyBezDodavateluHeaders: [
        { text: 'Produkt', value: 'nazev', sortable: false }
      ],
      pagination: {
        descending: false,
        page: 1,
        rowsPerPage: 25,
        sortBy: "ks",
        totalItems: 0
      },
      produkty: [],
      jednorazove_nakupy_produkty: [],
      ostatni_produkty: [],
      fixace: [],
      vyrobci: [],
      materialy: [],
      dodavatele: [],
      dialog: false,
      aktualni_stav: "",
      problem: null,
      pridat_produkt_id: null,
      pridat_produkt_id: null,
      loading_produkt: false,
      loading_produkt: false,
      status: null,
      produkty_bez_dodavatelu: [],
      objednavka_ok: false,
      metal_konto_dodavatele: [],
      stavy_metal_konto: []
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
    produkty: {
      handler (v) {
        if (this.status == "ok")
          this.resolve();
      },
      deep: true
    },
    jednorazove_nakupy_produkty: {
      handler (v) {
        if (this.status == "ok")
          this.resolve();
      },
      deep: true
    },
    ostatni_produkty: {
      handler (v) {
        if (this.status == "ok")
          this.resolve();
      },
      deep: true
    }
  },
  methods: {
    load: function() {
      window.API.get("dodavatele/nova-objednavka").then(function(b) {
        this.status = b.status;
        if (b.status == "ok") {
          this.stavy_metal_konto = b.metal_konto;
          this.metal_konto_dodavatele = b.dodavatele.filter((e) => { return e.metal_konto; });
          this.fixace = b.fixace;
          var _id = 0;
          this.produkty = b.produkty.map((e) => {
            var local_row_id = _id++;
            e.row_id = "sp-" + local_row_id.toString();
            e.hlidat_metal_konto = true;
            e.stav_metal_konta = null;
            return e;
          });
          _id = 0
          this.jednorazove_nakupy_produkty = b.jednorazove_produkty.map((e) => {
            var local_row_id = _id++;
            e.row_id = "jp-" + local_row_id.toString();
            e.hlidat_metal_konto = true;
            return e;
          });
          this.materialy = b.materialy;
          this.dodavatele = b.dodavatele.map((e) => {
            return {
              id: e.id,
              nazev: e.nazev,
              produkty: [],
              metal_konto: 0,
              ma_metal_konto: e.metal_konto
            };
          });
          this.loading = false;
          this.$nextTick(() => {
            this.resolve();
          });
        }
        else if (b.status == "error_produkty_bez_dodavatelu") {
          this.produkty_bez_dodavatelu = b.produkty_bez_dodavatelu;
          this.loading = false;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    resolve () {
      var $dodavatele = window.th.copy(this.dodavatele);
      for (var $i = 0; $i < this.produkty.length; $i++) {

        //if (parseFloat(this.produkty[$i].g) > 0) {

          var $dodavatel = this.produkty[$i].metal_konto_dodavatel_id;
          var $material = this.produkty[$i].cilovy_produkt.material;

          var material_index = this.materialy.indexOf(this.materialy.filter((e) => { return e.id == $material.id })[0]);

          var $f = $dodavatele.filter((e) => { return e.id == $dodavatel; });
          var $idx = $dodavatele.indexOf($f[0]);
          var $pr = $dodavatele[$idx].produkty.filter((e) => { return e.typ == "metal_konto" && e.material_id == $material.id; });

          if ($pr.length > 0) {
            var $idx_pr = $dodavatele[$idx].produkty.indexOf($pr[0]);
            $dodavatele[$idx].produkty[$idx_pr].metal_konto += parseFloat(this.produkty[$i].g);
          }
          else {
            $dodavatele[$idx].produkty.push({
              id: $dodavatel + "xmetalx" + (0 - this.materialy.length + material_index),
              typ: "metal_konto",
              material_id: $material.id,
              nazev: ($dodavatele[$idx].metal_konto == 0 ? "" : "Interní ") + "Metal konto - " + $material.nazev,
              ks: 0 - this.materialy.length + material_index,
              metal_konto: parseFloat(this.produkty[$i].g),
              hlidat_metal_konto: this.produkty[$i].hlidat_metal_konto
            });
          }

        //}

        //if (parseInt(this.produkty[$i].ks) > 0) {

          var $dodavatel = this.produkty[$i].dodavatel_id;
          var $produkt = this.produkty[$i].cilovy_produkt.id;
          var $f = $dodavatele.filter((e) => { return e.id == $dodavatel; });
          var $idx = $dodavatele.indexOf($f[0]);
          var $pr = $dodavatele[$idx].produkty.filter((e) => { return e.id == $produkt; });

          if ($pr.length > 0) {
            var $idx_pr = $dodavatele[$idx].produkty.indexOf($pr[0]);
            $dodavatele[$idx].produkty[$idx_pr].ks += this.parseIntNull(this.produkty[$i].ks);
            //$dodavatele[$idx].metal_konto += parseFloat(this.produkty[$i].g);
          }
          else {
            $dodavatele[$idx].produkty.push({
              id: $dodavatel + "x" + this.produkty[$i].cilovy_produkt.id,
              typ: "produkt",
              produkt_id: this.produkty[$i].cilovy_produkt.id,
              nazev: this.produkty[$i].cilovy_produkt.nazev,
              ks: this.parseIntNull(this.produkty[$i].ks),
              hlidat_metal_konto: this.produkty[$i].hlidat_metal_konto
            });
            //$dodavatele[$idx].metal_konto += parseFloat(this.produkty[$i].g);
          }

        //}

        if (this.produkty[$i].nahradni_produkt != null) {

          var $dodavatel = this.produkty[$i].nahradni_produkt.dodavatel_id;
          var $produkt = this.produkty[$i].nahradni_produkt.id;
          var $f = $dodavatele.filter((e) => { return e.id == $dodavatel; });
          var $idx = $dodavatele.indexOf($f[0]);
          var $pr = $dodavatele[$idx].produkty.filter((e) => { return e.id == $produkt; });

          if ($pr.length > 0) {
            var $idx_pr = $dodavatele[$idx].produkty.indexOf($pr[0]);
            $dodavatele[$idx].produkty[$idx_pr].ks += this.parseIntNull(this.produkty[$i].nahradni_produkt.ks);
            //$dodavatele[$idx].metal_konto += parseFloat(this.produkty[$i].g);
          }
          else {
            $dodavatele[$idx].produkty.push({
              id: $dodavatel + "x" + this.produkty[$i].cilovy_produkt.id + "x" + this.produkty[$i].nahradni_produkt.id,
              typ: "produkt",
              produkt_id: this.produkty[$i].nahradni_produkt.id,
              nazev: this.produkty[$i].nahradni_produkt.nazev,
              ks: this.parseIntNull(this.produkty[$i].nahradni_produkt.ks),
              hlidat_metal_konto: this.produkty[$i].hlidat_metal_konto
            });
            //$dodavatele[$idx].metal_konto += parseFloat(this.produkty[$i].g);
          }

        }

      }

      for (var $i = 0; $i < this.jednorazove_nakupy_produkty.length; $i++) {

        //if (parseInt(this.jednorazove_nakupy_produkty[$i].ks) > 0) {

          var $dodavatel = this.jednorazove_nakupy_produkty[$i].dodavatel_id;
          var $produkt = this.jednorazove_nakupy_produkty[$i].cilovy_produkt.id;
          var $f = $dodavatele.filter((e) => { return e.id == $dodavatel; });
          var $idx = $dodavatele.indexOf($f[0]);
          if ($idx == -1) {
            var a = "";
          }

          if ($idx >= 0) {

            var $pr = $dodavatele[$idx].produkty.filter((e) => { return e.id == $produkt; });

            if ($pr.length > 0) {
              var $idx_pr = $dodavatele[$idx].produkty.indexOf($pr[0]);
              $dodavatele[$idx].produkty[$idx_pr].ks += this.parseIntNull(this.jednorazove_nakupy_produkty[$i].ks);
              //$dodavatele[$idx].metal_konto += parseFloat(this.produkty[$i].g);
            }
            else {
              $dodavatele[$idx].produkty.push({
                id: $dodavatel + "x" + this.jednorazove_nakupy_produkty[$i].cilovy_produkt.id,
                typ: "produkt",
                produkt_id: this.jednorazove_nakupy_produkty[$i].cilovy_produkt.id,
                nazev: this.jednorazove_nakupy_produkty[$i].cilovy_produkt.nazev,
                ks: this.parseIntNull(this.jednorazove_nakupy_produkty[$i].ks),
                hlidat_metal_konto: this.jednorazove_nakupy_produkty[$i].hlidat_metal_konto
              });
              //$dodavatele[$idx].metal_konto += parseFloat(this.produkty[$i].g);
            }

          }

        //}

        //if (parseFloat(this.jednorazove_nakupy_produkty[$i].g) > 0) {

          var $dodavatel = this.jednorazove_nakupy_produkty[$i].metal_konto_dodavatel_id;
          var $material = this.jednorazove_nakupy_produkty[$i].cilovy_produkt.material;

          var material_index = this.materialy.indexOf(this.materialy.filter((e) => { return e.id == $material.id })[0]);

          var $f = $dodavatele.filter((e) => { return e.id == $dodavatel; });
          var $idx = $dodavatele.indexOf($f[0]);
          var $pr = $dodavatele[$idx].produkty.filter((e) => { return e.typ == "metal_konto" && e.material_id == $material.id; });

          if ($pr.length > 0) {
            var $idx_pr = $dodavatele[$idx].produkty.indexOf($pr[0]);
            $dodavatele[$idx].produkty[$idx_pr].metal_konto += parseFloat(this.jednorazove_nakupy_produkty[$i].g);
          }
          else {
            $dodavatele[$idx].produkty.push({
              id: $dodavatel + "xmetalx" + (0 - this.materialy.length + material_index),
              typ: "metal_konto",
              material_id: $material.id,
              nazev: ($dodavatele[$idx].metal_konto == 0 ? "" : "Interní ") + "Metal konto - " + $material.nazev,
              ks: 0 - this.materialy.length + material_index,
              metal_konto: parseFloat(this.jednorazove_nakupy_produkty[$i].g),
              hlidat_metal_konto: this.jednorazove_nakupy_produkty[$i].hlidat_metal_konto
            });
          }

        //}

      }

      for (var $i = 0; $i < this.ostatni_produkty.length; $i++) {

        //if (parseInt(this.ostatni_produkty[$i].ks) > 0) {

          var $dodavatel = this.ostatni_produkty[$i].dodavatel_id;
          var $produkt = this.ostatni_produkty[$i].cilovy_produkt.id;
          var $f = $dodavatele.filter((e) => { return e.id == $dodavatel; });
          var $idx = $dodavatele.indexOf($f[0]);
          if ($idx == -1) {
            var a = "";
          }
          var $pr = $dodavatele[$idx].produkty.filter((e) => { return e.id == $produkt; });

          if ($pr.length > 0) {
            var $idx_pr = $dodavatele[$idx].produkty.indexOf($pr[0]);
            $dodavatele[$idx].produkty[$idx_pr].ks += this.parseIntNull(this.ostatni_produkty[$i].ks);
            //$dodavatele[$idx].metal_konto += parseFloat(this.produkty[$i].g);
          }
          else {
            $dodavatele[$idx].produkty.push({
              id: $dodavatel + "x" + this.ostatni_produkty[$i].cilovy_produkt.id,
              typ: "produkt",
              produkt_id: this.ostatni_produkty[$i].cilovy_produkt.id,
              nazev: this.ostatni_produkty[$i].cilovy_produkt.nazev,
              ks: this.parseIntNull(this.ostatni_produkty[$i].ks),
              hlidat_metal_konto: this.ostatni_produkty[$i].hlidat_metal_konto
            });
            //$dodavatele[$idx].metal_konto += parseFloat(this.ostatni_produkty[$i].g);
          }

        //}

        //if (parseFloat(this.ostatni_produkty[$i].g) > 0) {

          var $dodavatel = this.ostatni_produkty[$i].metal_konto_dodavatel_id;
          var $material = this.ostatni_produkty[$i].cilovy_produkt.material;

          var material_index = this.materialy.indexOf(this.materialy.filter((e) => { return e.id == $material.id })[0]);

          var $f = $dodavatele.filter((e) => { return e.id == $dodavatel; });
          var $idx = $dodavatele.indexOf($f[0]);
          var $pr = $dodavatele[$idx].produkty.filter((e) => { return e.typ == "metal_konto" && e.material_id == $material.id; });

          if ($pr.length > 0) {
            var $idx_pr = $dodavatele[$idx].produkty.indexOf($pr[0]);
            if (this.ostatni_produkty[$i].hlidat_metal_konto)
              $dodavatele[$idx].produkty[$idx_pr].metal_konto += parseFloat(this.ostatni_produkty[$i].g);
          }
          else {
            $dodavatele[$idx].produkty.push({
              id: $dodavatel + "xmetalx" + (0 - this.materialy.length + material_index),
              typ: "metal_konto",
              material_id: $material.id,
              nazev: ($dodavatele[$idx].metal_konto == 0 ? "" : "Interní ") + "Metal konto - " + $material.nazev,
              ks: 0 - this.materialy.length + material_index,
              metal_konto: this.ostatni_produkty[$i].hlidat_metal_konto ? parseFloat(this.ostatni_produkty[$i].g) : 0,
              hlidat_metal_konto: this.ostatni_produkty[$i].hlidat_metal_konto
            });
          }

        //}

      }

      this.vyrobci = $dodavatele.filter((e) => { return e.produkty.length > 0 && e.produkty.filter((x) => { return (x.typ == "produkt" && parseFloat(x.ks) != 0) || (x.typ == "metal_konto" && parseFloat(x.metal_konto) != 0); }).length > 0; }).map((e) => {
          e.produkty = e.produkty.filter((x) => { return (x.typ == "produkt" && parseFloat(x.ks) != 0) || (x.typ == "metal_konto" && parseFloat(x.metal_konto) != 0); });
          return e;
      });

      this.objednavka_ok = this.vyrobci.filter((e) => { return e.produkty.filter((x) => { return (x.typ == "produkt" && x.ks < 0) || (x.typ == "metal_konto" && x.metal_konto < 0); }).length > 0; }).length == 0;

      console.log(this.vyrobci);
    },
    vytvoritObjednavku () {
      this.dialog = true;
      this.aktualni_stav = "Sestavuji objednávku";
      this.problem = null;
      window.API.post("dodavatele/vytvorit-objednavku", {
        fixace: this.fixace,
        dodavatele: this.vyrobci
      }).then((b) => {
        if (b.success) {
          this.dialog = false;
          this.e1 = 2;
          this.$router.push({ path: '/dodavatele/objednavky' });
        }
        else {
          this.problem = "Objednávka nemohla být vytvořena.";
        }
      }).catch((e) => {
        this.problem = "Objednávka nemohla být vytvořena.";
        console.log(e);
      })
    },
    pridatProduktClick () {
      this.loading_produkt = true;
      if (this.pridat_produkt_id != null) {
        window.API.get("dodavatele/nova-objednavka/produkty/"+this.pridat_produkt_id.toString()).then(function(b) {
          b.produkty.forEach(function (d) {
            d.hlidat_metal_konto = true;
            d.stav_metal_konta = null;
            //console.log(this.produkty.filter((e) => { return e.cilovy_produkt.id == d.cilovy_produkt.id; }).length);
            // if (this.produkty.filter(function (e) {
            //   return e.cilovy_produkt.id == d.cilovy_produkt.id;
            // }).length == 0) {
            //   this.jednorazove_nakupy_produkty.push(d);
            // }
            this.ostatni_produkty.push(d);
          }.bind(this));
          b.dodavatele.forEach((d) => {
            d.produkty = [];
            d.metal_konto = 0;
            if (this.dodavatele.filter((e) => {
              return e.id == d.id
            }).length == 0) {
              this.dodavatele.push(d);
            }
          });
          this.loading_produkt = false;
          this.pridat_produkt_id = null;
          this.$nextTick(() => {
            this.resolve();
          });
        }.bind(this)).catch(function(err) {
          console.log(err);
        }.bind(this));
      }
    },
    aktualizovatStavMetalKonta (v) {
      v.stav_metal_konta = this.stavy_metal_konto.filterOne((k) => { return k.material_id == v.cilovy_produkt.material.id && k.dodavatel_id == v.metal_konto_dodavatel_id; });
    },
    parseIntNull (v) {
      return v != null && v.toString().length > 0 ? parseInt(v) : 0;
    }
  },
  components: {

  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Dodavatele/DodavateleNovaObjednavka.vue